import React from 'react'
import iconFB from './assets/vector/bnFaceBook.svg';
import iconTwitter from './assets/vector/bnTwitter.svg';
import iconLinkedIn from './assets/vector/bnLinkedIn.svg';

import bnLogo from './assets/vector/NanoLogo.svg';
import LinkArrow from './assets/Shared/ExturnalLink.svg';
import Menu from './assets/Shared/Menu.svg';
import Close from './assets/Shared/Close.svg';
import Arrow from './assets/Shared/Arrow.svg';

// Home
import AdvancedPrograming from './assets/Icons/Home/AdvancedPrograming.svg';
import AnimationAndMotion from './assets/Icons/Home/AnimationAndMotion.svg';
import AssetCreation from './assets/Icons/Home/AssetCreation.svg';
import CloudComputing from './assets/Icons/Home/CloudComputing.svg';
import DeviceDeployment from './assets/Icons/Home/DeviceDeployment.svg';
import ExtendedReality from './assets/Icons/Home/ExtendedReality.svg';
import FullStackEng from './assets/Icons/Home/FullStackEng.svg';
import MachineLearning from './assets/Icons/Home/MachineLearning.svg';
import ProductVisualization from './assets/Icons/Home/ProductVisualization.svg';
import UserExperience from './assets/Icons/Home/UserExperience.svg';

import homeImage1 from './assets/Images/HOMEHero_2x.png';
import homeImage2 from './assets/Images/HOMEHeroStack_2x.png';
import badnanoLogo from './assets/Projects/Badnano.svg';

// IllusionAR
import AugmentedReality from './assets/Icons/Illusions/AugmentedReality.svg';
import LayeredContent from './assets/Icons/Illusions/LayeredContent.svg';
import SharedWorlds from './assets/Icons/Illusions/SharedWorlds.svg';
import TradableCurrency from './assets/Icons/Illusions/TradableCurrency.svg';
import MultiplayerContent from './assets/Icons/Illusions/MultiplayerContent.svg';
import PersistentCloud from './assets/Icons/Illusions/PersistentCloud.svg';
import AugmentedApplications from './assets/Icons/Illusions/AugmentedApplications.svg';
import CuttingEdgeTools from './assets/Icons/Illusions/CuttingEdgeTools.svg';
import TurnbyTurn from './assets/Icons/Illusions/TurnbyTurn.svg';
import PatentedTechnology from './assets/Icons/Illusions/PatentedTechnology.svg';

import iarImage1 from './assets/Images/IARHero_2x.png';
import iarImage2 from './assets/Images/IARHeroStack_2x.png';
import illusionsLogo from './assets/Projects/IllusionsAR.svg';

// FastDetect
import PCRGoldStandard from './assets/Icons/Fastdetect/PCRGoldStandard.svg';
import HIPAACompliant from './assets/Icons/Fastdetect/HIPAACompliant.svg';
import RealTimeReporting from './assets/Icons/Fastdetect/RealTimeReporting.svg';
import SamplePooling from './assets/Icons/Fastdetect/SamplePooling.svg';
import SmartCloud from './assets/Icons/Fastdetect/SmartCloud.svg';
import SecurePassport from './assets/Icons/Fastdetect/SecurePassport.svg';
import EmbeddedSystem from './assets/Icons/Fastdetect/EmbeddedSystem.svg';

import fdImage1 from './assets/Images/FDHero_2x.png';
import fdImage2 from './assets/Images/FDHeroStack_2x.png';
import fastdetectLogo from './assets/Projects/FastDetect.svg';

// Tete
import EndtoEndEncryption from './assets/Icons/Tete/EndtoEndEncryption.svg';
import SecurePayments from './assets/Icons/Tete/SecurePayments.svg';
import Appointments from './assets/Icons/Tete/Appointments.svg';
import ScreenSharing from './assets/Icons/Tete/ScreenSharing.svg';
import VideoConferencing from './assets/Icons/Tete/VideoConferencing.svg';
import RealTimeMessaging from './assets/Icons/Tete/RealTimeMessaging.svg';
import FileSharing from './assets/Icons/Tete/FileSharing.svg';
import Blackboard from './assets/Icons/Tete/Blackboard.svg';
import PaidSubscriptions from './assets/Icons/Tete/PaidSubscriptions.svg';

import teteImage1 from './assets/Images/TETEHero_2x.png';
import teteImage2 from './assets/Images/TETEHeroStack_2x.png';
import teteLogo from './assets/Projects/TeTe.svg';

// Letsbuild
import FitnessTracking from './assets/Icons/Letsbuild/FitnessTracking.svg';
import WorkoutScheduling from './assets/Icons/Letsbuild/WorkoutScheduling.svg';
import DietAnalysis from './assets/Icons/Letsbuild/DietAnalysis.svg';
import WeightMonitoring from './assets/Icons/Letsbuild/WeightMonitoring.svg';
import SleepProcessing from './assets/Icons/Letsbuild/SleepProcessing.svg';

import lbImage1 from './assets/Images/LBHero_2x.png';
import lbImage2 from './assets/Images/LBHeroStack_2x.png';
import letsBuildLogo from './assets/Projects/LetsBuild.svg';

// Intellikey
import ArtificialIntelligence from './assets/Icons/IntelliKey/ArtificialIntelligence.svg';
import GenerativePretrainingTransformer from './assets/Icons/IntelliKey/GenerativePretrainingTransformer.svg';
import NativeKeyboard from './assets/Icons/IntelliKey/NativeKeyboard.svg';
import OpenAI from './assets/Icons/IntelliKey/OpenAI.svg';
import PromptCompletion from './assets/Icons/IntelliKey/PromptCompletion.svg';
import PromptEngineering from './assets/Icons/IntelliKey/PromptEngineering.svg';
import PromptSharing from './assets/Icons/IntelliKey/PromptSharing.svg';
import SpeechRecognition from './assets/Icons/IntelliKey/SpeechRecognition.svg';
import TextToSpeech from './assets/Icons/IntelliKey/TextToSpeech.svg';
import WritingAssistant from './assets/Icons/IntelliKey/WritingAssistant.svg';

import IkImage1 from './assets/Images/IKHero_2x.png';
import IkImage2 from './assets/Images/IKHeroStack_2x.png';
import IntellikeyLogo from './assets/Projects/IKBNLogo.svg';

// Buttons
import intelliKeyButton from './assets/Projects/butIntellikey.svg';
import letsBuildButton from './assets/Projects/butLetsBuild.svg';
import fastDetectButton from './assets/Projects/butFastDetect.svg';
import illusionsARButton from './assets/Projects/butIllusionsAR.svg';
import TeteButton from './assets/Projects/butTete.svg';

const defaultVideo = 'https://storage.googleapis.com/badnano.appspot.com/VideoFade.mp4'

class Me {

    nanoHome = {
        name: 'HOME',
        logo: badnanoLogo,
        headline: 'Cutting-edge design and software engineering across all platforms',
        images: [
            {id: 1, media: homeImage1},
            {id: 2, media: homeImage2}
        ],
        features: [
            {id: 1, name: 'User Experience', media: UserExperience},
            {id: 2, name: 'Full Stack Engineering', media: FullStackEng},
            {id: 3, name: 'Animation And Motion', media: AnimationAndMotion},
            {id: 4, name: 'Functional Programing', media: AdvancedPrograming},
            {id: 5, name: 'Machine Learning', media: MachineLearning},
            {id: 6, name: 'Realtime Visualization', media: ProductVisualization},
            {id: 7, name: 'Extended Reality', media: ExtendedReality},
            {id: 8, name: 'Asset Creation', media: AssetCreation},
            {id: 9, name: 'Cloud Computing', media: CloudComputing},
            {id: 10, name: 'Hardware Deployment', media: DeviceDeployment}
        ],
        buttons: [
            {id: 1, title: intelliKeyButton, icon: Arrow, link: 'P2R', internal: true},
            {id: 2, title: letsBuildButton, icon: Arrow, link: 'LB', internal: true},
            {id: 3, title: illusionsARButton, icon: Arrow, link: 'IAR', internal: true},
            {id: 4, title: TeteButton, icon: Arrow, link: 'TETE', internal: true},
            {id: 5, title: fastDetectButton, icon: Arrow, link: 'FD', internal: true},
            {id: 6, title: 'Contact', info: 'info@badnano.com', icon: LinkArrow, link: 'HOME', hlink: 'mailto:info@badnano.com?subject=[Badnano]', internal: false}  
        ]
    }

    nanoLetsBuild = {
        name: 'LB',
        logo: letsBuildLogo,
        headline: 'Fully Connected Personal Training',
        images: [
            {id: 1, media: lbImage1},
            {id: 2, media: lbImage2}
        ],
        features: [
            {id: 1, name: 'Fitness Tracking', media: FitnessTracking},
            {id: 2, name: 'Workout Scheduling', media: WorkoutScheduling},
            {id: 3, name: 'Diet Analysis', media: DietAnalysis},
            {id: 4, name: 'Weight Monitoring', media: WeightMonitoring},
            {id: 5, name: 'Sleep Processing', media: SleepProcessing},
            {id: 6, name: 'Video Conferencing', media: VideoConferencing},
            {id: 7, name: 'Real-time Messaging', media: RealTimeMessaging},
            {id: 8, name: 'File Sharing', media: FileSharing},
            {id: 9, name: 'Multi-draw blackboard', media: Blackboard},
            {id: 10, name: 'Appointment Scheduling', media: Appointments}
        ],
        buttons: [
            {id: 1, title: "Let's Build", info: 'website', icon: LinkArrow, link: 'LB', hlink: 'https://letsbuild.fitness', internal: false}
        ] 
    }

    nanoPlanToRelax = {
        name: 'P2R',
        logo: IntellikeyLogo,
        headline: 'GPT Keyboard',
        images: [
            {id: 1, media: IkImage1},
            {id: 2, media: IkImage2}
        ],
        features: [
            {id: 1, name: 'User Experience', media: UserExperience},
            {id: 2, name: 'Full Stack Engineering', media: FullStackEng},
            {id: 3, name: 'Artificial Intelligence', media: ArtificialIntelligence},
            {id: 4, name: 'Prompt Engineering', media: PromptEngineering},
            {id: 5, name: 'Generative Pretraining Transformer', media: GenerativePretrainingTransformer},
            {id: 6, name: 'OpenAI Integration', media: OpenAI},
            {id: 7, name: 'Prompt Completion', media: PromptCompletion},
            {id: 8, name: 'Prompt Sharing', media: PromptSharing},
            {id: 9, name: 'Speech Recognition', media: SpeechRecognition},
            {id: 10, name: 'Text To Speech', media: TextToSpeech},
            {id: 11, name: 'Writing Assistant', media: WritingAssistant},
            {id: 12, name: 'Native Keyboard', media: NativeKeyboard},
            {id: 13, name: 'Asset Creation', media: AssetCreation},
            {id: 14, name: 'Cloud Computing', media: CloudComputing}
        ],
        buttons: [
            {id: 1, title: "IntelliKey", info: 'website', icon: LinkArrow, link: 'P2R', hlink: 'https://intellikey.app', internal: false}
        ] 
    }
  
    nanoIllusionsAR = {
        name: 'IAR',
        logo: illusionsLogo,
        headline: 'Shared Augmented Reality',
        images: [
            {id: 1, media: iarImage1},
            {id: 2, media: iarImage2}
        ],
        features: [
            {id: 1, name: 'Augmented Reality', media: AugmentedReality},
            {id: 2, name: 'Layered Content', media: LayeredContent},
            {id: 3, name: 'Shared Worlds', media: SharedWorlds},
            {id: 4, name: 'Tradable Currency', media: TradableCurrency},
            {id: 5, name: 'Multiplayer Content', media: MultiplayerContent},
            {id: 6, name: 'Persistent Cloud', media: PersistentCloud},
            {id: 7, name: 'Applications', media: AugmentedApplications},
            {id: 8, name: 'Cutting Edge Tools', media: CuttingEdgeTools},
            {id: 9, name: 'Turn-by-Turn Directions', media: TurnbyTurn},
            {id: 10, name: 'Patented Technology', media: PatentedTechnology}
        ],
        buttons: [
            {id: 1, title: "IllusionsAR.com", info: 'website', icon: LinkArrow, link: 'IAR', hlink: 'https://www.illusionsar.com', internal: false}
        ]
    }

    nanoTete = {
        name: 'TETE',
        logo: teteLogo,
        headline: 'Advanced HIPAA/GDPR Compliant Communication for Business',
        images: [
            {id: 1, media: teteImage1},
            {id: 2, media: teteImage2}
        ],
        features: [
            {id: 1, name: 'End-to-End Encryption', media: EndtoEndEncryption},
            {id: 2, name: 'HIPAA Compliant', media: HIPAACompliant},
            {id: 3, name: 'Secure Payments', media: SecurePayments},
            {id: 4, name: 'Appointment Scheduling', media: Appointments},
            {id: 5, name: 'Screen Sharing', media: ScreenSharing},
            {id: 6, name: 'Video Conferencing', media: VideoConferencing},
            {id: 7, name: 'Real-time Messaging', media: RealTimeMessaging},
            {id: 8, name: 'File Sharing', media: FileSharing},
            {id: 9, name: 'Multi-draw blackboard', media: Blackboard},
            {id: 10, name: 'Paid Subscriptions', media: PaidSubscriptions}
        ],
        buttons: [
            // {id: 1, title: "TeTe.video", info: 'website', icon: LinkArrow, link: 'TETE', hlink: 'https://www.tete.video', internal: false}
        ]
    }

    nanoFastDetect = {
        name: 'FD',
        logo: fastdetectLogo,
        headline: 'Cloud-based Rapid RT-PCR COVID Testing',
        images: [
            {id: 1, media: fdImage1},
            {id: 2, media: fdImage2}
        ],
        features: [
            {id: 1, name: 'PCR Gold Standard', media: PCRGoldStandard},
            {id: 2, name: 'HIPAA Compliant', media: HIPAACompliant},
            {id: 3, name: 'Real-time Reporting', media: RealTimeReporting},
            {id: 4, name: 'Sample Pooling', media: SamplePooling},
            {id: 5, name: 'Smart Cloud', media: SmartCloud},
            {id: 6, name: 'Secure Passport', media: SecurePassport},
            {id: 7, name: 'Rapid Testing Device', media: EmbeddedSystem},
            {id: 8, name: 'Patented Technology', media: PatentedTechnology}
        ],
        buttons: [
            // {id: 1, title: "FastDetect.com", info: 'website', icon: LinkArrow, link: 'FD', hlink: 'https://www.fastdetect.com', internal: false}
        ]
    }

    getProjectLinks = () => {
        return ([
            // {id: 0, name: 'HOME', url: 'https://badnano.com/', code: 'BN'},
            {id: 4, name: 'IntelliKey', url: 'https:/intellikey.app', code: 'P2R'},
            {id: 2, name: 'Illusions AR', url: 'https://www.illusionsar.com/', code: 'IAR'},
            {id: 3, name: 'TeTe', url: 'https://tete.video/', code: 'TETE'},
            {id: 4, name: 'FastDetect', url: 'https://fastdetect.com/', code: 'FD'},
            {id: 1, name: 'Lets Build', url: 'https://www.letsbuild.fitness/', code: 'LB'},
        ]);
    }
    
    getProjectLinksMobile = () => {
        return ([
            {id: 0, name: 'HOME', url: 'https://badnano.com/', code: 'HOME'},
            {id: 4, name: 'IntelliKey', url: 'https://intellikey.app', code: 'P2R'},
            {id: 2, name: 'Illusions AR', url: 'https://www.illusionsar.com/', code: 'IAR'},
            {id: 1, name: 'Lets Build', url: 'https://www.letsbuild.fitness/', code: 'LB'},
            {id: 3, name: 'TeTe', url: 'https://tete.video/', code: 'TETE'},
            {id: 4, name: 'FastDetect', url: 'https://fastdetect.com/', code: 'FD'},
        ]);
    }

    getSocialLinks = () => {
        return ([
            {id: 1, name: 'FaceBook', url: 'https://www.facebook.com/badnanocorp', media: iconFB},
            {id: 2, name: 'Twitter', url: 'https://twitter.com/BadNanoCorp', media: iconTwitter},
            {id: 3, name: 'LinkedIn', url: 'https://www.linkedin.com/company/badnano', media: iconLinkedIn}
        ]);
    }

    getDefaultVideo = () => {
        return(defaultVideo);
    }

    getLinkArrow = () => {
        return(LinkArrow);
    }

    getMenu = () => {
        return(Menu);
    }

    getClose = () => {
        return(Close);
    }

    getArrow = () => {
        return(Arrow);
    }

    getBNLogo = () => {
        return(bnLogo);
    }    
	
	getTitle = () => {
        return("test");
    }
}

const me = new Me()
const getMe = () => me

export { getMe }
